export class meetingMeta_pObj {

    selectedBetCategory : string;
    eventLable : string;
    eventName : string;
    eventLocalDate : Date;
    eventTime : Date;
    track_type: string;
    going: string;
    trifecta: boolean;
    raceType: string;
    handicap: boolean;
    maxrunners: string;
    amount:string;
    eligibilty_type:string;
    distance:string;   
    lastWinnerHorsePrice:string;
    lastWinnerYear:string;
    lastWinnerHorse:string;
    lastWinnerHorseWeightText:string;
    lastWinnerRan :string;
    lastWinnerHorseTrainerName : string;
    lastWinnerHorseJockeyName : string;
    lastWinnerHorseAgeYears : number;
    
}
export class meetingMeta_greyHound_pObj{
    selectedBetCategory: string;
    eventLable: string;
    eventName :string;
    eventLocalDate:Date;
    eventTime :Date;
    greyhound_type: string;
    greyhound_class: string;
    greyhound_handicap: string;
    greyhound_distance: number;
    
}